"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNote = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledNote = _styledComponents["default"].p.withConfig({
  displayName: "style__StyledNote",
  componentId: "buwz4e-0"
})(["margin-top:5px;font-size:14px;"]);

exports.StyledNote = StyledNote;